/**
 * Created by lari on 27/04/2017.
 */
(function () {
    'use strict';
    angular.module('vcexam')
      .component('examgdtfiles', {
        restrict: 'E',
        bindings: {
          // examinations: '='
          examid: '<'
        },
        // templateUrl: 'exam/currentexams-component.tpl.html',
        template: `
        <div ng-show="vm.files.length > 0">
        <div class="spacer-top"></div>
          <div class="panel panel-default">
            <div class="panel-heading">
                <h4 style="vertical-align: baseline">
                    <div class="pull-left">PDFs der Untersuchung</div>
                    <div class="pull-right"> 1 
                      <span class="switch" ng-click="vm.toggleImgNr()">
                        <input type="checkbox" ng-model="vm.img3">
                        <span class="slider round"></span>
                      </span>  3 Bilder pro Zeile
                    </div>
                    <div class="clearfix"></div>
                </h4>
            </div>
            <div class="panel-body">
              <div class="col-xs-{{vm.colwidth}}" ng-repeat="file in vm.files | filter: {active: true}">
                <a  href="/routes/files/filereader/{{file.fileid}}" target="_blank"><i class="fa fa-file-pdf-o fa-4x"></i></a><br>
                <div><input type="checkbox" ng-model="file.print" ng-change="vm.save(file)">&nbsp;mit  Befund ausdrucken</div>
                <div><input type="text" ng-model="file.label"  ng-blur="vm.save(file)" class="form-control"></div>
              </div>
            </div>
        </div>
        <div class="clearfix spacer-bottom"></div>  
      `,
        controllerAs: 'vm',
        controller: ['$log', 'Rlog', 'File', 'vertxEventBusService', '$window',
          function ($log, Rlog, File, vertxEventBusService, $window) {
            let vm = this;
            vm.img3 = true;
            vm.colwidth = 4;
            vm.save = save;
            vm.deleteFile = deleteFile;

            // vm.toggleImgNr = toggleImgNr;

            vm.$onInit = function () {
              if (angular.isDefined(vm.examid)) {
                let query = {examid: vm.examid};
                File.$search(query).$then(function (files) {
                  vm.files = files;
                }, function (err) {
                  $log.error('examfiles lookup failed for examid id: ', vm.examid);
                  Rlog.error('exam', 'examfiles', 'examfiles lookup failed', {examid: vm.examid});
                })
              }
            };

            // vm.examid might be late propagating, get exams on first change
            vm.$onChanges = function (changes) {
              if (!changes.isFirstChange) {
                // if (angular.isDefined(changes.examid.currentValue)) {
                vm.examid = changes.examid.currentValue;
                if (angular.isDefined(vm.examid)) {
                  File.$search({examid: vm.examid}).$then(function (files) {
                    vm.files = files;
                    // $log.debug('******* current exam files : ', files);
                  }, function (err) {
                    $log.error('examfiles lookup failed for examid id: ', vm.examid);
                    Rlog.error('exam', 'examfiles', 'examfiles lookup failed', {examid: vm.examid});
                  });
                }
              }
            };

/*            function toggleImgNr() {
              vm.img3 = !vm.img3;

              if (vm.img3 === true) {
                vm.colwidth = 4;
              } else {
                vm.colwidth = 12;
              }
              $log.debug('vm.img3 :', vm.img3);
              $log.debug('vm.colwidth :', vm.colwidth);
            }*/

            function deleteFile (file) {
              file.active = false;
              vm.save(file);
            }

            function save(file) {
              if (file.$hasPendingActions()) {
                file.$cancel();
              }
              file.$save().$then(function () {
              }, function () {
                Rlog.debug('exam', 'examfiles', 'file delete save failed', {examid: exam._id, fileid: file._id});
              });
            }


            // TODO: figure out how to conviniently sync label and include file updates
            vertxEventBusService.on('examfile.update', function (message) {
              $log.debug('****** Examfiles update received: ', message);
              vm.files.$refresh().$then(function () {
                $log.debug('debug: examfiles refreshed');
              }, function (error) {
                $log.debug('debug: examfiles could not refresh exams: ', error);
              });
            });

          }] // controller
      }); // component

// klammerfriedhof
  }
  ()
)
;